'use strict';


var yaml = require('./lib/js-yaml.js');


module.exports = yaml;



//////////////////
// WEBPACK FOOTER
// ../js/~/js-yaml/index.js
// module id = 641
// module chunks = 0